import React, { memo } from "react";
import { questionHasChildren } from "../../../../../projection/question/question.typeguards";
import { useQuestionItem } from "./behaviours/useQuestionItem";
import { QuestionLayout } from "./components/questionLayout/QuestionLayout";
const Question = ({ domain, question, questionParentId, level = 0, tradename, country, segment, }) => {
    const Item = useQuestionItem({ type: question.type });
    return (React.createElement(Item, { country: country, domain: domain, level: level, question: question, questionParentId: questionParentId, segment: segment, tradename: tradename }, questionHasChildren(question) && (React.createElement(QuestionLayout, { country: country, domain: domain, level: level, question: question, segment: segment, tradename: tradename }))));
};
const memorizedQuestion = memo(Question);
export { memorizedQuestion as Question };
